import {AxiosInstance} from "axios";

export type StrongCustomerAuthorizationApiType = ReturnType<
  typeof strongCustomerAuthorizationApi
>;

const strongCustomerAuthorizationApi = (
  axiosInstance: AxiosInstance,
  clubId: number,
) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    sendEmail(invoiceNumber: string) {
      return axiosInstance.put(`${clubPrefix}invoice/${invoiceNumber}/send-auth-email/`);
    },
    generateScaRedirectUrl(invoiceNumber: string) {
      return `${axiosInstance.defaults.baseURL}/club/${clubId}/sca/invoice/${invoiceNumber}`;
    },
  };
};

export default strongCustomerAuthorizationApi;
